import { createSelector } from 'reselect';
import { p13nSelector } from 'selectors/p13n/p13nSelector';

const recapP13nABTestSelector = createSelector(p13nSelector, p13n => p13n?.recapABTestData);

export { recapP13nABTestSelector };
